import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import { SERVICE_STATUS } from '@bagonboard/wiseman';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

// eslint-disable-next-line import/extensions
import sweetAlertStyle from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx';

import * as actions from '../../../../../reducers/Service/actions';
import CustomDropdown from '../../../../../components/CustomDropdown/CustomDropdown';
import {
  ButtonDetails, buttonStyles, Container, Margin,
} from './style';

const {
  CANCELLED, DECLINED, PENDING, ASSIGNED,
} = SERVICE_STATUS;

const LABELS = {
  cancellled: 'Cancelled by customer',
  declined  : 'Declined by Bob',
};

class Footer extends React.Component {
  state = {
    showDialog  : false,
    actionStatus: null,
  };

  onBagTagsClick = () => {
    const { id } = this.props;
    window.open(`${process.env.REACT_APP_BOOKING_BOB}iata?code=${id}`);
  };

  onCancelClick = (e) => {
    if (LABELS.cancellled === e) {
      this.setState({ showDialog: true, actionStatus: CANCELLED });
    }
    if (LABELS.declined === e) {
      this.setState({ showDialog: true, actionStatus: DECLINED });
    }
  };

  onCloseDialog = () => {
    this.setState({ showDialog: false });
  };

  successCancel = () => {
    const { updateServiceStatus, id } = this.props;
    const { actionStatus } = this.state;
    this.onCloseDialog();
    updateServiceStatus({ serviceId: id, status: actionStatus });
  };

  render() {
    const { classes, status } = this.props;
    const { showDialog, actionStatus } = this.state;
    const showCancel = [PENDING, ASSIGNED].includes(status);

    return (
      <Fragment>
        <Container>
          {showCancel && (
            <CustomDropdown
              hoverColor="danger"
              buttonText="CANCEL SERVICE"
              buttonProps={{
                style: buttonStyles,
              }}
              dropdownHeader="Choose the reason"
              dropdownList={[LABELS.cancellled, LABELS.declined]}
              onClick={this.onCancelClick}
            />
          )}
          <Margin />
          <ButtonDetails onClick={this.onBagTagsClick} variant="outlined">
            SEE BAG TAGS
          </ButtonDetails>
        </Container>
        <SweetAlert
          cancelBtnCssClass={`${classes.button} ${classes.success}`}
          cancelBtnText="Close"
          confirmBtnCssClass={`${classes.button} ${classes.danger}`}
          confirmBtnText={actionStatus === CANCELLED ? 'Yes, cancel it!' : 'Yes, decline it!'}
          onCancel={this.onCloseDialog}
          onConfirm={this.successCancel}
          show={showDialog}
          showCancel
          style={{ marginTop: '-200px' }}
          title="Are you sure?"
          warning
        >
          {actionStatus === CANCELLED
            ? 'You will mark this service as cancelled and you will not be able to recover it!'
            : 'You will mark this service as declined and you will not be able to recover it!'}
        </SweetAlert>
      </Fragment>
    );
  }
}
Footer.propTypes = {
  classes: PropTypes.shape({
    button : PropTypes.string,
    success: PropTypes.string,
    danger : PropTypes.string,
  }).isRequired,
  updateServiceStatus: PropTypes.func,
  id                 : PropTypes.string,
  status             : PropTypes.string,
};
Footer.defaultProps = {
  updateServiceStatus() {},
  id    : '',
  status: '',
};

const mapDispatchToProps = dispatch => ({
  updateServiceStatus: data => dispatch(actions.updateServiceStatus(data)),
});

export default compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
  withStyles(sweetAlertStyle),
)(Footer);
